import * as React from "react";
import { observable, action } from "mobx";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import ProfileStore from "../../../stores/profileStore";
import { ILocalization } from "../../../models/localization";
import { ProfileSkillState, ExperienceType, JobType, EdType, EmptyId, AddExpRoute } from "../../../models/enums";
import { Row, Col } from "react-flexbox-grid";
import Button from 'material-ui/Button';
import AddIcon from 'material-ui-icons/Add';
import Tooltip from 'material-ui/Tooltip';
import * as s from "./addBtn.css";

export default class FloatingAddBtn extends React.Component<{ store: SeekerStore, value?: ExperienceType, n?: number}, {}> {

  constructor(props: any) {
    super(props);
  }

  @action handleClick = (): void => {
    let num: number = this.props.n;
    switch (num) {
      case 0:
        //add new credential 
        this.props.store.profileStore.setAddExpRoute(AddExpRoute.Cclc);
        hashHistory.push("/profile/add-experience/" + this.props.value);
        break;
      case 1:
        //add new experience
        this.props.store.profileStore.setAddExpRoute(AddExpRoute.Experience);
        hashHistory.push("/profile/add-experience");
        break;
      case 2:
        //add new skill
        if(this.props.store.profileStore.skillsViewMode === ProfileSkillState.AddSkillView){
          this.props.store.profileStore.setSkillsViewMode(ProfileSkillState.NoSelection);         
          this.props.store.profileStore.setRefreshAddSkillVw(true);
         }
        this.props.store.profileStore.setSkillsViewMode(2);
        break;
      case 3:
        //add new language
        this.props.store.profileStore.setAddExpRoute(AddExpRoute.Lanuage);
        hashHistory.push("/profile/add-experience/" + this.props.value);
        break;
      default:
        break;
    }   
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const styles = {
      MuiIconButton: {
        backgroundColor: "#EA7600",
        color: "#FFF",
        margin: "16px 0px 12px",
        float: "right",
      },
    };


    return <Row bottom="sm" className={s.positionRow}>
      <Col xs={12}>
        <Tooltip id="tooltip-fab" title={local.add} >
          <Button fab color="primary" aria-label="floating-add" onClick={() => this.handleClick()} style={styles.MuiIconButton} >
              <AddIcon />
            </Button>
          </Tooltip> 
        </Col>
      </Row>;}
}


// WEBPACK FOOTER //
// ./src/components/widgets/addBtn/index.tsx